<div #stripeCardModal id="stripe-card-modal"
  class="hidden popup-modal fixed right-0 left-0 top-0 dev-height sm:top-4 z-max sm:justify-center items-center sm:inset-0 sm:h-modal">
  <div
    class="flex min-w-full items-center justify-center min-h-screen sm:pt-4 sm:px-4 sm:pb-20 text-center sm:block sm:p-0">
    <div class="fixed bg-gray-900 bg-opacity-50 dark:bg-opacity-80 inset-0 transition-opacity" aria-hidden="true"></div>

    <!-- This element is to trick the browser into centering the modal contents. -->
    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

    <div
      class="scrollable-content-container main-container dev-height sm:h-auto inline-block align-bottom bg-white popup px-4 sm:pt-5 sm:pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:align-middle sm:max-w-sm sm:w-full sm:p-6">
      <div class="sm:block absolute top-0 right-0 pt-4 pr-4">
        <button (click)="hide()" type="button"
          class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none">
          <span class="sr-only">Close</span>
          <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
            aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div>
        <div class="text-left">
          <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-title2" i18n>Payment Details</h3>
          <div class="mt-6">
            <form #checkout="ngForm">
              <div class="form-group form-label-group">
                <div class="form-group credit-card-control form-label-group col-md-12">
                  <div id="card-element" class="StripeElement--complete">
                    <!-- A Stripe Element will be inserted here. -->
                  </div>
                  <!-- Used to display form errors. -->
                  <div id="card-errors" role="alert" class="text-red-500 text-sm mt-2"></div>
                </div>
              </div>
            </form>
          </div>

          <div class="mt-5 sm:mt-6">
            <button 
                id="stripe-pay-button" 
                type="button" 
                (click)="confirmPayment()" 
                [disabled]="isProcessing"
                class="w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700">
                <span class="button-text">Pay Now</span>
                <div class="spinner ml-2"></div>
            </button>
            
            <!-- Add Stripe security badge -->
            <div class="flex justify-center">
              <img src="/assets/images/stripe-badge-transparent.png" 
                   alt="Secured by Stripe" 
                   class="w-full"
                   style="object-fit: contain;">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
